export const areFieldsEqual = (obj1, obj2, fields) => {
    try {
        for (let field of fields) {
            if (obj1[field] !== obj2[field]) {
                return false;  // Values for a field are different
            }
        }

        return true;  // All fields are equal
    } catch (error) {
        console.error('Error comparing:', error.message);
        return false;
    }
}